import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { AuthRoutingModule } from "./auth-routing.module";
import { LoginComponent } from "./pages/login/login.component";
import { SharedModule } from "@shared/shared.module";
import { NgxPermissionsModule } from "ngx-permissions";
import { AuthComponent } from "./auth.component";
import { ResetPasswordComponent } from "./pages/reset-password/reset-password.component";
import { ModalModule } from "ngx-bootstrap/modal";
import { AsaasLoginComponent } from "./pages/asaas-login/asaas-login.component";
import { AsaasLoginErrorComponent } from "./pages/asaas-login-error/asaas-login-error.component";
import { AsaasLoginOverlayComponent } from "@modules/auth/component/asaas-login-overlay/asaas-login-overlay.component";
import { AsaasComponent } from "./pages/asaas/asaas.component";
import { ValidationErrorsComponent } from "@shared/utils/forms/validation-errors/validation-errors.component";
@NgModule({
	declarations: [
		LoginComponent,
		AuthComponent,
		ResetPasswordComponent,
		AsaasComponent,
		AsaasLoginComponent,
		AsaasLoginErrorComponent,
		AsaasLoginOverlayComponent
	],
	imports: [
		CommonModule,
		AuthRoutingModule,
		ModalModule.forChild(),
		NgxPermissionsModule.forChild(),
		SharedModule,
		TranslateModule,
		ValidationErrorsComponent
	]
})
export class AuthModule {}
